import { Injectable } from '@angular/core';
import { Order, QueryConfig, QueryEntity } from '@datorama/akita';
import { MessagesState, MessagesStore } from './messages.store';
import { MessageInterface } from './message-interface.model';

@Injectable({
    providedIn: 'root'
})
@QueryConfig({
    sortBy: 'createDate',
    sortByOrder: Order.ASC
})
export class MessagesQuery extends QueryEntity<MessagesState, MessageInterface> {
    constructor(protected override store: MessagesStore) {
        super(store);
    }

    public getHasMore() {
        return this.getValue().hasMore;
    }

    public getPage() {
        return this.getValue().page;
    }
}
